import { render, staticRenderFns } from "./MyPageOld.vue?vue&type=template&id=5a675e42&scoped=true&"
import script from "./MyPageOld.vue?vue&type=script&lang=js&"
export * from "./MyPageOld.vue?vue&type=script&lang=js&"
import style0 from "./MyPageOld.vue?vue&type=style&index=0&id=5a675e42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a675e42",
  null
  
)

export default component.exports